import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/login", { replace: true }); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data.user);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        if (!data.user.role_selected) {
          navigate("/select-role", { replace: true, state: { user: data.user } });
        } else {
          navigate("/dashboard", { replace: true, state: { user: data.user } });
        }
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--adn-cream)]">
      <div className="text-[var(--adn-text-soft)] text-sm">Signing you in…</div>
    </div>
  );
}
